import { clearSandboxProvisionCache } from "@/pages/canvas/nodes/widgets/terminal/sandboxProvision";
import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect } from "react";

const Logout: React.FC = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    // Drop any cached sandbox terminal URLs/tokens before the Auth0 redirect tears down module state.
    clearSandboxProvisionCache();
    const ROOT_URL = window.location.origin;
    logout({ logoutParams: { returnTo: ROOT_URL } });
  }, []);

  return null;
};

export default Logout;
